import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card } from "../components/ui/card";
import { Zap, LogIn } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@fieldflow.com");
  const [password, setPassword] = useState("admin123");
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Willkommen zurück!");
      nav("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || err.message || "Login fehlgeschlagen");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-stretch bg-background text-foreground">
      {/* Left brand panel */}
      <div className="hidden lg:flex flex-1 relative overflow-hidden"
           style={{
             backgroundImage: `url('https://static.prod-images.emergentagent.com/jobs/b32cd628-f485-4eb3-b984-45d7e428b05e/images/6b32ddd8a43ade16ccc523379a6ae2ee1611e75030553280479c930edaf58fbf.png')`,
             backgroundSize: "cover", backgroundPosition: "center"
           }}>
        <div className="absolute inset-0 bg-gradient-to-br from-background/80 via-background/50 to-transparent" />
        <div className="relative z-10 flex flex-col justify-between p-12 text-foreground">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-2xl bg-primary text-primary-foreground flex items-center justify-center">
              <Zap className="w-6 h-6" />
            </div>
            <span className="font-heading text-2xl font-bold">Navero</span>
          </div>
          <div className="space-y-4 max-w-md">
            <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight">
              Einsatz. Route. Erfolg.
            </h1>
            <p className="text-muted-foreground text-lg">
              Die All-in-One Plattform für Ihr Außendienst-Team. Planen, optimieren und abrechnen — in einem System.
            </p>
          </div>
          <div className="text-xs text-muted-foreground">© Navero 2026</div>
        </div>
      </div>

      {/* Right form */}
      <div className="flex-1 flex items-center justify-center p-6 md:p-12 bg-grain">
        <Card className="w-full max-w-md p-8 md:p-10 rounded-3xl border border-border/60 glass">
          <div className="mb-8">
            <div className="text-xs text-muted-foreground font-bold uppercase tracking-[0.2em] mb-2">Login</div>
            <h2 className="font-heading text-3xl font-bold">Willkommen zurück</h2>
            <p className="text-muted-foreground mt-1 text-sm">Melden Sie sich in Ihrem Konto an.</p>
          </div>
          <form onSubmit={submit} className="space-y-5" data-testid="login-form">
            <div className="space-y-2">
              <Label htmlFor="email">E-Mail</Label>
              <Input id="email" data-testid="login-email" type="email" value={email}
                     onChange={(e) => setEmail(e.target.value)} required
                     className="rounded-full h-11 px-5" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Passwort</Label>
              <Input id="password" data-testid="login-password" type="password" value={password}
                     onChange={(e) => setPassword(e.target.value)} required
                     className="rounded-full h-11 px-5" />
            </div>
            <Button type="submit" disabled={loading} data-testid="login-submit"
                    className="w-full rounded-full h-11 font-semibold">
              <LogIn className="w-4 h-4 mr-2" />
              {loading ? "Anmelden..." : "Anmelden"}
            </Button>
          </form>
          <div className="mt-6 text-center text-sm text-muted-foreground">
            Noch kein Konto? <Link to="/register" className="text-primary font-semibold hover:underline" data-testid="link-register">Registrieren</Link>
            <span className="mx-2">·</span>
            <Link to="/forgot-password" className="text-primary font-semibold hover:underline" data-testid="link-forgot">Passwort vergessen?</Link>
          </div>
          <div className="mt-6 rounded-2xl bg-secondary/50 p-3 text-xs text-muted-foreground">
            <div className="font-semibold text-foreground mb-1">Demo-Accounts</div>
            <div>Admin: admin@fieldflow.com / admin123</div>
            <div>Techniker: tech@fieldflow.com / tech123</div>
          </div>
        </Card>
      </div>
    </div>
  );
}
